import React from "react";
import { Megaphone, Wallet, RefreshCw, FileText } from "lucide-react";
import { ANNOUNCEMENTS } from "../demoData";
import { Card, PageTitle } from "../ui";

const TAGS = {
  "New Offer": [Megaphone, "text-purple-300 bg-purple-500/15"],
  Payout: [Wallet, "text-emerald-300 bg-emerald-500/15"],
  Update: [RefreshCw, "text-blue-300 bg-blue-500/15"],
  Policy: [FileText, "text-amber-300 bg-amber-500/15"],
};

export default function Announcements() {
  return (
    <>
      <PageTitle title="Announcements" sub="News, new offers and payout updates from Digital Master Media." />
      <div className="space-y-4 max-w-3xl">
        {ANNOUNCEMENTS.map((a, i) => {
          const [Icon, cls] = TAGS[a.tag];
          return (
            <Card key={a.title} className="p-5 flex gap-4" testId={`announcement-${i}`}>
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${cls}`}><Icon className="w-5 h-5" /></div>
              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full ${cls}`}>{a.tag}</span>
                  <span className="text-xs text-slate-500">{a.date}</span>
                </div>
                <h3 className="mt-2 font-semibold text-white">{a.title}</h3>
                <p className="mt-1 text-sm text-slate-400">{a.body}</p>
              </div>
            </Card>
          );
        })}
      </div>
    </>
  );
}
